var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.33398 6.33369C1.334 5.59182 1.55905 4.86741 1.97941 4.25613C2.39977 3.64485 2.99566 3.17546 3.68839 2.90995C4.38112 2.64445 5.13809 2.59532 5.85933 2.76905C6.58056 2.94278 7.23213 3.33121 7.72798 3.88302C7.76291 3.92036 7.80513 3.95013 7.85203 3.97049C7.89894 3.99084 7.94952 4.00134 8.00065 4.00134C8.05178 4.00134 8.10236 3.99084 8.14927 3.97049C8.19617 3.95013 8.23839 3.92036 8.27332 3.88302C8.76761 3.32762 9.41933 2.93593 10.1417 2.76009C10.8641 2.58424 11.623 2.63258 12.3172 2.89867C13.0115 3.16477 13.6082 3.63599 14.0281 4.24962C14.4479 4.86325 14.6709 5.59019 14.6673 6.33369C14.6673 7.86035 13.6673 9.00035 12.6673 10.0004L9.00598 13.5424C8.88176 13.685 8.7286 13.7996 8.55668 13.8786C8.38476 13.9575 8.19801 13.9989 8.00884 14.0001C7.81967 14.0013 7.63242 13.9622 7.45951 13.8855C7.2866 13.8088 7.132 13.6961 7.00598 13.555L3.33398 10.0004C2.33398 9.00035 1.33398 7.86702 1.33398 6.33369Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.ea795b19dd81c9ae900c20bf73fd5747.svg";
export { ForwardRef as ReactComponent };